import { QueryClient } from '@tanstack/vue-query'

/**
 * The one query cache. Exported so the router can ask the same questions the
 * pages ask (a workspace's access, before opening one of its pages) and the
 * page then answers from the cache instead of asking again.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // An engine run is expensive; nothing here should refetch on a tab focus.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 60_000,
    },
  },
})
